import { baseSepolia, sepolia } from "wagmi/chains";
import AXIR_SOCIAL_RECOVERY_ABI from "./ABIs/AxirSocialRecoveryABI.json";

export const SUPPORTED_CHAINS = [baseSepolia, sepolia];

export const CONTRACT_ADDRESSES = {
  [baseSepolia.id]: "0xEf5Eb6f6b4aa14aAb81137E781fb3738Dee9e94F", // Base Sepolia address
  [sepolia.id]: "0xE56baf332bcf5dff398D2f8BF58D225EB46aa63e", // Replace with actual Optimism Sepolia address
};

export const CONTRACT_CONFIG = {
  abi: AXIR_SOCIAL_RECOVERY_ABI,
  addresses: CONTRACT_ADDRESSES,
};

// Helper function to get contract address for current chain
export const getContractAddress = (chainId) => {
  return CONTRACT_ADDRESSES[chainId];
};

// Helper function to check if chain is supported
export const isSupportedChain = (chainId) => {
  return Object.keys(CONTRACT_ADDRESSES).includes(chainId.toString());
};

// Get chain name helper
export const getChainName = (chainId) => {
  const chain = SUPPORTED_CHAINS.find((chain) => chain.id === chainId);
  return chain ? chain.name : "Unsupported Chain";
};
